import style from "./ProductManagementLayout.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { useEffect, useRef, useState } from "react";
import { adminRequester } from "App";
import TableSearchCard from "routes/table/search/TableSearchCard";
import SingleAdminTable from "../table/SingleAdminTable";
import P from "components/P";
import NiceModal from "@ebay/nice-modal-react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import TableButton from "../table/TableButton";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import clsx from "clsx";
import { t } from "i18next";
import ToolTip from "components/tooltip/tooltip";

export const limit = 20;

function ProductManagementLayout(props) {
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchCondition, setSearchCondition] = useState();
  const { keyword } = useParams();
  const [theader, setTheader] = useState([]);
  const [outs, setOuts] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [reset, setReset] = useState(false);
  const [research, setResearch] = useState(false);
  const [extraCondition, setExtraCondition] = useState({});
  const [views, setViews] = useState([]);
  const [productsStatus, setProductsStatus] = useState();
  const [outputHeader, setOutputHeader] = useState([]);
  const researchInterval = useRef();
  const navigate = useNavigate();
  useEffect(() => {
    adminRequester.getProductStatus(
      {
        ...extraCondition,
        ...searchCondition,
        offset: page * limit,
        limit: limit,
      },
      (result) => {
        setCount(result.count);
        setMaxPage(result.count / limit);
        setData(result.products);
      }
    );
  }, [page, searchCondition]);
  useEffect(() => {
    if (reset) {
      setData([]);
      setReset(false);
      setMaxPage(0);
      setCount(0);
    }
  }, [reset]);
  useEffect(() => {
    if (research) {
      adminRequester.getProductStatus(
        {
          ...extraCondition,
          ...searchCondition,
          offset: page * limit,
          limit: limit,
        },
        (result) => {
          setCount(result.count);
          setMaxPage(result.count / limit);
          setData(result.products);
        }
      );
      setResearch(false);
    }
  }, [research]);
  useEffect(() => {
    let indexes = [];
    let buttons = [];
    switch (keyword) {
      default: {
        adminRequester.getProductStatus({ status: "search" }, (result) => {
          const productsStatus = result.data;
          setProductsStatus([
            {
              text: "전체",
              count: productsStatus && productsStatus.list,
            },
            {
              text: "판매중",
              count: productsStatus && productsStatus.sale,
            },
            {
              text: "판매중지",
              count: productsStatus && productsStatus.not_sale,
            },
            {
              text: "진열",
              count: productsStatus && productsStatus.show,
            },
            {
              text: "미진열",
              count: productsStatus && productsStatus.hide,
            },
          ]);
        });
        indexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        const outputHeader = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        buttons = [
          "productDisplay",
          "productUndisplay",
          "productNotSold",
          "productSold",
          "productCopy",
          "productDelete",
          "productCategory",
          "mainDisplay",
          "productRegist",
        ];
        setViews(["AllProduct"]);
        setExtraCondition({});
        setOutputHeader(outputHeader.map((index) => outputHeaderList[index]));
        break;
      }
    }
    setButtons(
      buttons
        // .map((code) => TableButton(code, () => setResearch(true)))
        .map((code) =>
          TableButton(
            code,
            code === "productCopy"
              ? () => {
                  if (researchInterval.current)
                    clearInterval(researchInterval.current);
                  researchInterval.current = setInterval(() => {
                    setResearch(true);
                    clearInterval(researchInterval.current);
                  }, 500);
                }
              : code === "productRegist"
              ? () => navigate("/admin/productRegistration")
              : code === "mainDisplay"
              ? () => NiceModal.show("mainDisplay")
              : () => setResearch(true)
          )
        )
        .filter((button) => !!button)
    );
    setTheader(indexes.map((index) => theaderList[index]));
    setReset(true);
  }, [keyword]);
  useEffect(() => {
    setOuts({
      getData: getOutput(outputHeader),
    });
  }, [outputHeader, extraCondition, searchCondition]);
  const callback = (searchCondition) => {
    setPage(0);
    setSearchCondition(searchCondition);
  };

  const dataCallback = (value) => {
    setData(value);
  };
  const openEdit = ({ row }) => {
    NiceModal.show("productStatus", {
      data: row,
      onSuccess: () => setResearch(true),
    });
  };

  const theaderList = [
    {
      width: 50,
      text: "No.",
      justifyContent: "flex-start",
      Cell: ({ index }) => index + 1,
      index: "0",
    },
    {
      width: 100,
      text: "상품구분",
      justifyContent: "flex-start",
      Cell: () => "기본상품",
      index: "1",
    },
    {
      width: 300,
      text: "상품코드",
      justifyContent: "flex-start",
      code: "id",
      hover: true,
      cursor: true,
      onClick: ({ cell }) => {
        navigator.clipboard.writeText(cell);
        toast.success("상품코드를 복사했습니다", {
          autoClose: 1000,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      },
      index: "2",
    },
    {
      width: 250,
      text: "상품명",
      justifyContent: "flex-start",
      code: "title",
      hover: true,
      cursor: true,
      Cell: ({ row, cell }) =>
        row?.thumbnail ? (
          <HorizontalFlex gap={5} justifyContent="flex-start">
            <FlexChild width="max-content">
              <img
                src={row.thumbnail}
                alt="empty"
                style={{ maxWidth: "50px", maxHeight: "50px" }}
              />
            </FlexChild>
            <FlexChild width="max-content">
              <P>{cell}</P>
            </FlexChild>
          </HorizontalFlex>
        ) : (
          cell
        ),
      onClick: openEdit,
      index: "4",
    },
    {
      width: 200,
      text: "판매가",
      justifyContent: "flex-start",
      Cell: ({ row }) => {
        if (row.price) {
          if (row?.discount_price !== row?.price) {
            return (
              <HorizontalFlex>
                <P>{Number(row.discount_price).toLocaleString("ko")}</P>
                <P style={{ textDecoration: "line-through" }}>
                  ({Number(row.price).toLocaleString("ko")})
                </P>
              </HorizontalFlex>
            );
          }

          return <P>{Number(row.price).toLocaleString("ko")}</P>;
        }

        return <P>0</P>;
      },
      index: "6",
    },
    {
      width: 200,
      text: "옵션명",
      justifyContent: "flex-start",
      code: "variants",
      Cell: ({ cell }) =>
        cell?.length > 0 && (
          <VerticalFlex>
            {cell?.map((variant) => (
              <ToolTip
                style={{
                  backgroundColor: "white",
                  width: "max-content",
                  padding: 10,
                  zIndex: 10,
                }}
                title={
                  variant.options?.length > 0 && (
                    <VerticalFlex>
                      {variant.options?.map((option, index) => (
                        <HorizontalFlex key={option.id} gap={10}>
                          {variant.options.length > 1 && (
                            <FlexChild width="max-content">{index}</FlexChild>
                          )}
                          <FlexChild width="max-content">
                            <P>{option.option.title}</P>
                          </FlexChild>
                          <FlexChild width="max-content">
                            <P>({option.value})</P>
                          </FlexChild>
                        </HorizontalFlex>
                      ))}
                    </VerticalFlex>
                  )
                }
              >
                <P>{variant.title}</P>
              </ToolTip>
            ))}
          </VerticalFlex>
        ),
      hover: true,
      cursor: true,
      onClick: openEdit,
      index: "5",
    },
    {
      width: 200,
      text: "옵션가",
      justifyContent: "flex-start",
      code: "variants",
      Cell: ({ cell }) => (
        <VerticalFlex width="max-content">
          {cell?.map((variant) => {
            if (variant?.price) {
              if (variant?.discount_price !== variant?.price) {
                return (
                  <HorizontalFlex key={variant.id}>
                    <P>{Number(variant.discount_price).toLocaleString("ko")}</P>
                    <P style={{ textDecoration: "line-through" }}>
                      ({Number(variant.price).toLocaleString("ko")})
                    </P>
                  </HorizontalFlex>
                );
              }
              return (
                <P key={variant.id}>
                  {Number(variant.price).toLocaleString("ko")}{" "}
                </P>
              );
            }
            return <P key={variant.id}>0</P>;
          })}
        </VerticalFlex>
      ),
      index: "6",
    },
    {
      width: 50,
      text: "재고량",
      justifyContent: "flex-start",
      code: "variants",
      Cell: ({ cell }) => (
        <VerticalFlex>
          {cell?.map((variant) => (
            <P>{variant?.inventory_quantity}</P>
          ))}
        </VerticalFlex>
      ),
      index: "7",
    },
    {
      width: 300,
      text: "옵션코드",
      justifyContent: "flex-start",
      code: "variants",
      Cell: ({ cell }) => (
        <VerticalFlex alignItems="flex-start">
          {cell?.map((variant) => (
            <FlexChild key={variant.id} width="max-content">
              <P
                hover={true}
                cursor={true}
                onClick={() => {
                  navigator.clipboard.writeText(variant?.id);
                  toast.success("옵션코드를 복사했습니다", {
                    autoClose: 1000,
                    position: toast.POSITION.BOTTOM_CENTER,
                  });
                }}
              >
                {variant.id}
              </P>
            </FlexChild>
          ))}
        </VerticalFlex>
      ),
      index: "3",
    },
    {
      width: 125,
      text: "상품상태",
      justifyContent: "flex-start",
      Cell: ({ row }) =>
        `${row?.buyable === true ? "판매중" : "구매불가"} / ${
          row?.status === "published" ? "전시중" : "비전시중"
        }`,
      index: "8",
    },
    {
      width: 100,
      text: "바로가기",
      justifyContent: "flex-start",
      Cell: ({ row }) =>
        row?.variants?.length > 0 ? (
          <a
            href={`/product/detail/${row?.variants?.[0]?.id}`}
            target="_blank"
            rel="noreferrer"
            className={style.url}
          >
            링크
          </a>
        ) : (
          "-"
        ),
      index: "9",
    },
    {
      width: 50,
      text: "메모",
      justifyContent: "flex-start",
      code: "id",
      Cell: ({ cell }) => {
        const [isOpen, setOpen] = useState(false);
        return (
          <div style={{ position: "relative" }}>
            <button onClick={() => setOpen(!isOpen)}>메모</button>
            {isOpen && (
              <div
                style={{
                  position: "absolute",
                  width: "max-content",
                  height: "max-content",
                  background: "#FFFFFF",
                  border: 1,
                  right: "120%",
                  top: "-50%",
                }}
              >
                임시 내용{cell}
              </div>
            )}
          </div>
        );
      },
      index: "10",
    },
  ];
  const outputHeaderList = [
    {
      text: "No.",
      code: "index",
      Cell: ({ index }) => index,
      index: "0",
    },
    {
      text: "상품구분",
      code: "productType",
      Cell: () => "기본상품",
      index: "1",
    },
    {
      text: "상품코드",
      code: "id",
      Cell: ({ cell }) => cell,
      index: "2",
    },
    {
      text: "옵션코드",
      code: "id",
      index: "3",
    },
    {
      text: "상품명",
      code: "title",
      Cell: ({ cell }) => cell,
      index: "4",
    },
    {
      text: "옵션명",
      code: "title",
      index: "5",
    },
    {
      text: "판매가",
      // Cell: ({ row }) =>
      //   row.price === row.discount_price
      //     ? row.price
      //     : `${row.discount_price}(${row.price})`,
      Cell: () => 0,
      index: "6",
    },
    {
      text: "재고량",
      // code: "inventory_quantity",
      code: "variants",
      Cell: ({ cell }) => 0,
      index: "7",
    },
    {
      text: "상품상태",
      Cell: ({ row }) =>
        `${row.buyable === true ? "판매중" : "구매불가"} / ${
          row.status === "published" ? "전시중" : "비전시중"
        }`,
      index: "8",
    },
    {
      text: "URL",
      code: "id",
      Cell: ({ cell }) =>
        `${process.env.REACT_APP_FRONT}/product/detail/${cell}`,
      index: "9",
    },
  ];
  const getOutput = (outputHeader) => {
    const output = async (data, indexes) => {
      let list;

      if (!indexes || indexes.length === 0) {
        list =
          (
            await adminRequester.getProductStatus({
              ...extraCondition,
              ...searchCondition,
            })
          ).products || [];
      } else {
        list = indexes.map((index) => ({
          ...data[index],
          // index: index + page * limit,
        }));
      }

      return {
        header: outputHeader,
        list: list,
        fileName: `상품_${new Date().getTime()}`,
      };
    };
    return output;
  };

  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <HorizontalFlex gap={10} justifyContent="flex-start">
            {views.map((view) => (
              <FlexChild width="max-content">
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                    fontSize: 18,
                    paddingBottom: "8px",
                    fontWeight: "700",
                  }}
                  className={clsx({
                    [style.clickable]: views.length > 1 && view !== keyword,
                    [style.selected]: view === keyword && views.length > 1,
                  })}
                  onClick={() => {
                    if (views.length > 0 && view !== keyword)
                      navigator(`/admin/productStatus/${view}`);
                  }}
                >
                  {t(view)}
                </div>
              </FlexChild>
            ))}
          </HorizontalFlex>
        </FlexChild>
        {productsStatus && productsStatus?.length > 0 && (
          <FlexChild>
            <div style={{ backgroundColor: "#f5f6fb", padding: "0 0 30px 0" }}>
              <div style={{ boxShadow: "1px 3px 10px 0 rgba(0, 35, 11, 0.2)" }}>
                <HorizontalFlex
                  backgroundColor={"white"}
                  padding={"15px"}
                  alignItems={"center"}
                  justifyContent={"flex-start"}
                >
                  {productsStatus.map((data, index) => {
                    return (
                      <FlexChild key={index} width={150}>
                        <HorizontalFlex justifyContent={"flex-start"} gap={10}>
                          <FlexChild width={"initial"}>
                            <P weight={"bold"}>{data.text}</P>
                          </FlexChild>
                          <FlexChild>
                            <P
                              weight={"bold"}
                              color={"var(--admin-main-color)"}
                            >
                              {data.count}{" "}
                            </P>
                            <P weight={"bold"}>건</P>
                          </FlexChild>
                        </HorizontalFlex>
                      </FlexChild>
                    );
                  })}
                </HorizontalFlex>
              </div>
            </div>
          </FlexChild>
        )}
        <FlexChild>
          <TableSearchCard
            callback={callback}
            index={1}
            keyword={keyword}
            reset={reset}
            setReset={setReset}
            research={research}
          />
        </FlexChild>
        <FlexChild>
          <SingleAdminTable
            keyword={keyword}
            theader={theader}
            count={count}
            mockData={data}
            initTabIndex={0}
            callback={dataCallback}
            output={outs}
            page={page}
            buttons={buttons}
            maxPage={maxPage}
            setPage={setPage}
            limit={limit}
            reset={reset}
            research={research}
          />
        </FlexChild>
      </VerticalFlex>
    </div>
  );
}

export default ProductManagementLayout;
